import {useParams} from "react-router";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {SLAReportDetailsContent} from "@/pages/reports/sla/details/SLAReportDetailsContent.tsx";

export const SLAReportDetails = () => {
  const {id} = useParams();
  const reportID = parseInt(id!);
  return (
    <UpErrorBoundary
      fallback={
        <ContentContainer title={`SLA Report #${reportID}`}>
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <SLAReportDetailsContent id={reportID} />
    </UpErrorBoundary>
  );
};
